import { render, staticRenderFns } from "./AttachPlus.vue?vue&type=template&id=5145b3cf&"
import script from "./AttachPlus.vue?vue&type=script&lang=js&"
export * from "./AttachPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports